<template>
  <div>
    <v-card color="#eceff1" flat>
      <v-expansion-panels flat style="background-color: #eceff1">
        <v-expansion-panel style="background-color: #eceff1">
          <v-expansion-panel-header>
            <v-card-title>Búsqueda avanzada</v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form v-model="isFormValid" ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="filtros.tipo_proceso"
                    :items="tiposProceso"
                    item-text="text"
                    item-value="value"
                    label="Tipo de Proceso"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filtros.base_mes"
                    label="Base Mes"
                    type="date"
                    dense
                    outlined
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    rounded
                    color="#cc092f"
                    outlined
                    class="ml-2"
                    @click="limpiar"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Limpiar
                  </v-btn>
                  <v-btn
                    color="#cc092f"
                    rounded
                    dark
                    :disabled="!canSearch"
                    :loading="loading"
                    class="ml-2"
                    @click="buscar"
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFormValid: false,
      loading: false,
      filtros: {
        tipo_proceso: null,
        base_mes: null,
      },
      tiposProceso: [
        { text: "Validación de errores carga base marcación", value: "Marcación" },
        { text: "Activar base de marcación", value: "Activar Base" },
        { text: "Inactivar base de marcación", value: "Desactivar Base" }
        // { text: "Cobranza", value: "Cobranza" },
        // { text: "Otros", value: "Otros" }
      ],
    };
  },

  computed: {
    canSearch() {
      return this.filtros.tipo_proceso || this.filtros.base_mes;
    },
  },

  methods: {
    buscar() {
      this.loading = true;
      this.$emit("buscar", { ...this.filtros });
    },

    limpiar() {
      this.filtros = {
        tipo_proceso: null,
        base_mes: null,
      };
      this.$emit("limpiar");
    },

    setLoading(loading) {
      this.loading = loading;
    },
  },

  mounted() {
    // Set default date to today
    const today = new Date();
    this.filtros.base_mes = today.toISOString().split("T")[0];
  },
};
</script>
